import { ApolloClient, InMemoryCache, from, } from "@apollo/client/core";
import * as apollo from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";
import { getAccessToken } from "@devforce/trailhead-client-auth";
import * as env from "@devforce/trailhead-client-env";
import { fetch } from "@devforce/trailhead-client-fetch";
import { getLocale } from "@devforce/trailhead-client-locale";
import { Logger } from "@devforce/trailhead-client-logger";
import { createUploadLink } from "apollo-upload-client";
const gql = apollo.gql;
export { apollo, gql };
export const PACKAGE_NAME = "@devforce/trailhead-client-apollo";
export const logger = new Logger({
    prefix: `[${PACKAGE_NAME}]: `,
});
const getApiHost = () => env.get("GRAPHQL_API_HOST") || env.get("EXPERIENCE_API_HOST");
const headersLink = setContext(async (request, { headers = {} }) => {
    let authHeader = {};
    let token = await getAccessToken();
    if (token !== null) {
        authHeader.Authorization = `Bearer ${token}`;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        headers: {
            ...headers,
            ...authHeader,
            "Accept-Language": getLocale(),
        },
    };
});
const contextMiddlewaresLink = setContext(async (request, context) => {
    return state.contextMiddlewares.reduce((promise, { name, setContext }) => {
        return promise.then((nextContext) => {
            logger.info(`Running setContext() for: "${name}"`);
            return setContext(request, nextContext);
        });
    }, Promise.resolve(context));
});
const uriLink = setContext(async (request, { uri = getApiHost() }) => {
    return {
        uri,
    };
});
export function createDefaultClient(uri = getApiHost()) {
    const link = createUploadLink({ fetch, uri });
    return new ApolloClient({
        cache: new InMemoryCache(),
        // @ts-ignore
        link: from([headersLink, uriLink, contextMiddlewaresLink, link]),
    });
}
export function getClient() {
    if (!state.client)
        state.client = createDefaultClient();
    return state.client;
}
export function setClient(client) {
    state.client = client;
}
export function registerContextMiddleware(middleware) {
    let names = new Set(state.contextMiddlewares.map((m) => m.name));
    if (names.has(middleware.name)) {
        throw new Error(`Middleware with name "${middleware.name}" is already registered`);
    }
    state.contextMiddlewares.push(middleware);
    return () => {
        state.contextMiddlewares = state.contextMiddlewares.filter((m) => m !== middleware);
    };
}
let state = {
    // Client is lazily initialized
    client: null,
    contextMiddlewares: [],
};
export function initializeState(currentState, existingState) {
    return existingState !== null && existingState !== void 0 ? existingState : currentState;
}
// This module may be executed multiple times from different sources
if (typeof window !== "undefined") {
    // @ts-ignore
    state = window[PACKAGE_NAME] = initializeState(state, window[PACKAGE_NAME]);
}
